module.exports = __webpack_public_path__ + "static/media/apache-guacamole.b6e9b721.png";